import { styled } from "@mui/material/styles";

const PhoneInputsMain = styled("div")(({ theme }) => ({
  marginBottom: "15px",
  position: "relative",
  "&.is__error": {
    "& input": {
      border: `1px solid ${theme.palette.error.main} `,
      color: theme.palette.error.main,
    },
  },
  "& .PhoneInputCountry": {
    background: "#F2F2F2",
    borderRadius: "10px",
    padding: "10px",
  },
  "& input": {
    width: "100%",
    height: "48px",
    background: "#F2F2F2",
    borderRadius: "10px",
    border: `1px solid transparent`,
    fontFamily: theme.typography.fontFamily,
    padding: "10px",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
    "&:focus": {
      outline: "none",
      borderColor: theme.palette.primary.main,
    },
    "::placeholder": {
      color: "rgba(11, 11, 11, 0.6)",
    },
  },
  "& span.error": {
    fontFamily: theme.typography.fontFamily,
    color: "red",
    fontWeight: 400,
    fontSize: "14px",
    position: "absolute",
    top: "100%",
    left: 0,
  },
}));

const CustomLabel = styled("label")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "25px",
  color: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,
  display: "block",
  marginBottom: "5px",
}));

export { PhoneInputsMain, CustomLabel };
